import React from "react";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Arrow = (props: any) => (
  <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M18.707 12.293a1 1 0 010 1.414l-6 6a1 1 0 01-1.414 0l-6-6a1 1 0 111.414-1.414L11 16.586V5a1 1 0 112 0v11.586l4.293-4.293a1 1 0 011.414 0z" />
  </svg>
);
